type Props = { fullScreen?: boolean };

export default function SpacesOrgAdminBlocker({ fullScreen }: Props) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center gap-3 ${
        fullScreen ? "h-[100dvh] bg-white font-mulish" : "h-full py-24"
      }`}
    >
      <p className="text-lg font-semibold text-gray-800">
        Select a teacher to access Spaces
      </p>
      <p className="text-sm text-gray-500">
        Use the account switcher to select a teacher account first.
      </p>
    </div>
  );
}
